import { CalendarComponent } from 'ng-fullcalendar';
import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { CALENDAR_DATA, CALENDAR_OPTIONS } from '../constants';

@Component({
    selector: 'atx-calendar',
    template: `<h1> Calendar </h1>

<div *ngIf="options">
    <ng-fullcalendar #ucCalendar
                     [options]="options"
                     [(eventsModel)]="model">
    </ng-fullcalendar>
</div>
`,
    styles: [``],
})

export class AtxCalendarComponent implements OnInit {
    @Input() public options;
    @Input() public readonly model = CALENDAR_DATA;

    @ViewChild(CalendarComponent) ucCalendar: CalendarComponent;

    public ngOnInit() {
        this.options = { ...CALENDAR_OPTIONS, ...this.options };
        this.options.events = this.model;
    }
}
